import { useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import StackedLineChartIcon from '@mui/icons-material/StackedLineChart';
import { Button } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useTaskCredit_GetCurrentTaskCreditQuery } from 'queries';

const useStyles = makeStyles(() => ({
  seePlansButton: {
    backgroundColor: '#1C2541',
    color: '#FFF',
    border: '1px solid #FFF',
    borderRadius: '8px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginRight: '20px',
    fontSize: '14px',
  },
  icon: {
    marginRight: '10px',
  },
}));

const SeePlansButton = () => {
  const { portalId } = useParams<Record<string, string>>();
  const history = useHistory();
  const classes = useStyles();

  const [userHasSubscription, setUserHasSubscription] = useState(false);

  const { loading: currentTaskCreditLoading } = useTaskCredit_GetCurrentTaskCreditQuery({
    skip: !portalId,
    variables: {
      portalId,
    },
    onCompleted: () => setUserHasSubscription(true),
  });

  if (!portalId || currentTaskCreditLoading || userHasSubscription) {
    return null;
  }

  return (
    <Button
      className={classes.seePlansButton}
      onClick={() => history.push(`/home/${portalId}/subscription-pricing-table`)}
    >
      <StackedLineChartIcon fontSize="small" className={classes.icon} />
      See plans
    </Button>
  );
};

export default SeePlansButton;
